import Loadable from "app/components/Loadable";
import { lazy } from "react";

const CoccidialStatusList = Loadable(lazy(() => import("./CoccidialStatusList")));
const CoccidialStatusForm = Loadable(lazy(() => import("./CoccidialStatusForm")));

const coccidialStatusRoutes = [
  {
    path: "/CoccidialStatus/CoccidialStatusList",
    element: <CoccidialStatusList />,
  },
  {
    path: "/CoccidialStatus/CoccidialStatusForm",
    element: <CoccidialStatusForm />,
  },
  {
    path: "/CoccidialStatus/CoccidialStatusForm/:coccidialStatusId",
    element: <CoccidialStatusForm />,
  },
];

export default coccidialStatusRoutes;
